import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useSearchParams } from 'react-router-dom';
import { postMAIAC010 } from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_PAYMENT } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas } from '../../../utils';
registerLocale('ko', ko);

const MAIAC010 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [pages, setPages] = useState({});
    const [searchCondition, setSearchCondition] = useState('MemberID');
    const [keyword, setKeyword] = useState('');
    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const getSearchCondition = (e) => {
        setSearchCondition(e.target.value);
    };

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    const getListData = (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;

        postMAIAC010({
            page: currentPage,
            searchCondition,
            keyword: keyword?.trim(),
            startDate: startDateFormated,
            endDate: endDateFormated,
        })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };

    const clickReset = () => {
        setSearchParams('');
        setStartDate('');
        setEndDate('');
        setDateRate('');
        setKeyword('');
        setSearchCondition('MemberID');
    };

    const getPaymentMethod = (payMethod) => {
        switch (payMethod) {
            case 'VCard':
                return '신용카드';
            case 'VBank':
                return '가상계좌';
            case 'EMTICKET':
                return 'Dvmall 이용권';
            case 'DirectBank':
                return '계좌이체';
            case 'Card':
                return '카드결제';
            default:
                return '';
        }
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);
    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_PAYMENT} />
                <div className="cancel-payment-content content-right things-to-checkList">
                    <div className="title title-cancel-payment">결제 취소 목록</div>
                    <div id="cancel-payment-content-list ">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>조건 검색</th>
                                    <td>
                                        <div className="flex-conditional-search">
                                            <div className="select-box">
                                                <select onChange={getSearchCondition} value={searchCondition}>
                                                    <option value="MemberID">회원 ID</option>
                                                    <option value="NameKor">이름</option>
                                                    <option value="GoodName">상품명</option>
                                                </select>
                                                <input
                                                    type="text"
                                                    placeholder="검색어 입력"
                                                    value={keyword}
                                                    onChange={inputChange}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>취소일</th>
                                    <td colSpan={3}>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>
                    <div className="results">
                        <div className="flex-top-item">
                            <div className="count-item">
                                총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                            </div>
                        </div>
                        <table className="table-gray">
                            <thead>
                                <tr>
                                    <th>취소일</th>
                                    <th style={{ width: '80px' }}>치과명</th>
                                    <th>회원 ID(이름)</th>
                                    <th>상품명</th>
                                    <th>결제금액</th>
                                    <th>결제수단</th>
                                    <th>취소 사유</th>
                                    <th style={{ width: '100px' }}>취소 관리자</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item) => (
                                        <tr key={item.seq}>
                                            <td>{formatDate(item.cancelDate)}</td>
                                            <td>{item.buyerCompany}</td>
                                            <td>
                                                {item.memberID}({item.nameKor})
                                            </td>
                                            <td>{item.goodName}</td>
                                            <td>{formatNumberWithCommas(item.crPrice)}</td>
                                            <td>{getPaymentMethod(item.payMethod)}</td>
                                            <td>{item.cancelMsg}</td>
                                            <td></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={8}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAIAC010;
